export namespace AddMaterialDialogModel {
  export enum ModeEnum {
    ADD_NEW = "add-new",
    ADD_EXISTING = "add-existing",
  }

  export const defaultMode: ModeEnum = ModeEnum.ADD_NEW;
}
